import script from "./StateFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./StateFooter.vue?vue&type=script&setup=true&lang=js"

import "./StateFooter.vue?vue&type=style&index=0&id=5afcc56a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afcc56a"]])

export default __exports__